<app-loader *ngIf="isLoading"></app-loader>
<div class="mb-0 name">
  <span>{{ "MYACCOUNT.PROFILE" | translate }}</span>

</div>
<div class="bg-white p-sm-4 p-3 mt-3 mb-5">
  <div class="">
    <div class="rounded-profileImg imgMain">
      <img *ngIf="
            (myAccountData?.avatarUrl === null && !avatarImage) || isProfileRemoved
          " src="assets/images/images.png" alt="" />
      <img *ngIf="avatarImage && !isProfileRemoved" [src]="avatarImage" alt="" />
      <span (click)="toggleModalforImage(true)">
        <img src="../../../assets/images/Ellipse 482profile image icon.svg" alt="" class='orangeButtonBackground'>
        <img src="../../../assets/images/Frameprofile icon new.png" alt="" class="pencilImg">
      </span>
    </div>
    <div class="modal mx-auto fade fixed top-0 left-0 w-100 h-100 outline-none overflow-y-auto " id="changeImageModal"
      data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel"
      aria-hidden="true">
      <div class="modal-dialog relative w-auto pointer-events-none modal-dialog-centered changeWidthHeight">
        <div
          class="modal-content border-none shadow-lg relative text-center  changeHeight rounded-25 pointer-events-auto bg-white outline-none p-md-5 p-3">
          <div class="d-flex justify-content-between align-items-center mb-4">
            <div>
              <h5 class="headingTextModal mb-0">
                {{ "MYACCOUNT.CHANGEPROFILEPIC" | translate }}
              </h5>
            </div>

          </div>
          <p class=" mb-3 leftTextModal">{{ "MYACCOUNT.PROFILEPICTEXT" | translate }}</p>
          <div class="d-flex align-items-center mt-2 mb-3">
            <div class="rounded-profileImgPopup">
              <img *ngIf="(myAccountData?.avatarUrl === null && !recentImageUrl) || isProfileRemoved"
                src="assets/images/images.png" alt="" />

              <img *ngIf="!isProfileRemoved && myAccountData?.avatarUrl && !recentImageUrl"
                [src]="myAccountData?.avatarUrl" alt="Current Profile" />

              <img *ngIf="!isProfileRemoved && recentImageUrl" id="popupimage" [src]='recentImageUrl' alt="" />
            </div>
            <div class="">
              <div class="flex-sm-row flex-column operatorsOptions">
                <div>
                  <input type="file" class="d-none" #fileInputModal accept="image/*" name="file" id="file"
                    (change)="handleFileInputImage($event);" />
                </div>
                <div class="changesImg pb-2" (click)="fileInputModal.click()">
                  <img src="/assets/images/Vector.svg" alt="" class="imgOperators">
                  <span class="fw-bold imgOperators--text">
                    {{ "MYACCOUNT.UPLOAD" | translate }}
                  </span>
                </div>
                <div class="changesImg pb-2" (click)="removeProfile()">
                  <img src="assets/images/Group 40782 (1).svg" alt="" class="imgOperators">
                  <span
                    [ngClass]="myAccountData?.avatarUrl === null? 'imgOperators--text':'fw-bold imgOperators--text'">
                    {{ "MYACCOUNT.REMOVE" | translate }}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="buttonAlign mt-3">
            <button class="px-5 py-2" [disabled]="!readyToUpload"
              [ngClass]="readyToUpload?'submit-btn bg-orgclr fw-bold':'q-myAccount-invalid-button'"
              (click)="uploadFile(selectedFiles)">
              {{ "MYACCOUNT.SAVE" | translate }}
            </button>
            <button type="button" class="cancel-btn bg-cancelbtnPopUp " data-bs-dismiss="modal"
              (click)="toggleModalforImage(false)">
              {{ "MANAGEDEVICE.REMOVEPROFILEPICTURE.CANCEL" | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="editMode" class="q-vertical-content" [ngClass]="
  selectedIndex === 0
    ? 'content-border-radius'
    : 'rounded-border-radius'">
    <ng-container>
      <app-add-user [isupdateProfile]="isupdateProfile" [updateUser]="myAccountData"
        (removeChildEvent)="disableEdit()"></app-add-user>
    </ng-container>
  </div>
  <form [formGroup]="verifyAccountForm" *ngIf="!editMode">
    <div class="row myAccountDetails">

      <div class="arrow cursor-pointer d-none d-md-block">
        <img [src]="'MANAGEDEVICE.PENIMG'|translate" (click)="enableEdit('editMode')" />
      </div>
      <div class="arrow cursor-pointer d-block d-md-none ms-5 ps-5">
        <img class="ms-5 ps-5" [src]="'MANAGEDEVICE.PENIMG' |translate" (click)="enableEdit('editMode')" />
      </div>

      <div *ngIf="!nameInputs" class="q-vertical-content-user">
        <ng-container>
          <div class="mt-2 ms-4 d-none d-md-block">
            <div class="row d-flex flex-wrap mb-3">
              <div class="col-2">
                <label class="q-tab-content-list-title">{{ "MYACCOUNT.FULLNAME" | translate }}</label>
              </div>
              <div class="col-3">
                <span title="{{ myAccountData?.name}}" class="q-tab-content-list-desc">
                  {{returnWithEllipses}}
                </span>
                <span class="q-tab-content-list-desc"> </span>
              </div>
            </div>

            <div class="row d-flex flex-wrap mb-3">
              <div class="col-2">
                <label class="q-tab-content-list-title">{{ "MYACCOUNT.ROLESS" | translate }} </label>
              </div>
              <div class="col-3">
                <span class="q-tab-content-list-desc">{{ myAccountData?.roleTypeStr
                  ? (myAccountData.roleType | translate)
                  : ('MYACCOUNT.NA' | translate) }}
                </span>
                <span class="q-tab-content-list-desc"> </span>
              </div>
            </div>

            <div class="row d-flex flex-wrap mb-3">
              <div class="col-2">
                <label class="q-tab-content-list-title">{{ "MANAGEDEVICE.PHONENO" | translate }} </label>
              </div>
              <div class="col-3">
                <span class="q-tab-content-list-desc" *ngIf="!mobileInput">
                  {{ myAccountData?.countryCode }} {{ myAccountData?.mobileNo == null
                  ? "N/A"
                  :myAccountData?.mobileNo }}
                </span>
                <span class="q-tab-content-list-desc"> </span>
              </div>
            </div>

            <div class="row d-flex flex-wrap mb-3">
              <div class="col-2">
                <label class="q-tab-content-list-title">{{ "MYACCOUNT.EMAIL" | translate }}</label>
              </div>
              <div class="col-3">
                <span class="q-tab-content-list-desc">{{ myAccountData?.email == null
                  ? "N/A"
                  :myAccountData?.email }}</span>
                <span class="q-tab-content-list-desc"> </span>
              </div>
            </div>

            <div class="row d-flex flex-wrap mb-3">
              <div class="col-2">
                <label class="q-tab-content-list-title">{{ "MYACCOUNT.AGE" | translate }} </label>
              </div>
              <div class="col-3">
                <span class="q-tab-content-list-desc">
                  {{ myAccountData?.age == null
                  ? "N/A"
                  : myAccountData?.age }}
                </span>
                <span class="q-tab-content-list-desc"> </span>
              </div>
            </div>

            <div class="row d-flex flex-wrap mb-3">
              <div class="col-2">
                <label class="q-tab-content-list-title">{{ "MYACCOUNT.GENDER" | translate }}</label>
              </div>
              <div class="col-3">
                <span class="q-tab-content-list-desc">
                  {{ getGenderLabel(myAccountData?.genderType) }}
                </span>
                <span class="q-tab-content-list-desc"> </span>
              </div>
            </div>


            <div class="form-group" *ngIf="nameInputs">
              <label class="level">{{ "MYACCOUNT.FULLNAME" | translate }} </label>
              <input type="text" formControlName="name" #name class="form-control q-form-control me-3" [maxlength]="40"
                style="max-width: 180px" [ngClass]="{ 'is-invalid': isSubmitted && f['name'].errors }"
                (keypress)="InputKeyPress($event)" />
            </div>
          </div>
        </ng-container>
        <ng-container>
          <div class="d-block d-md-none">
            <tab-content>
              <span title1>{{ "MYACCOUNT.FULLNAME" | translate }} : </span>
              <span desc1 title="{{ myAccountData?.name}}" class="text-capitalize">
                {{returnWithEllipses}}
              </span>
              <span title2>{{ "MYACCOUNT.ROLESS" | translate }} : </span>
              <span desc2>{{ myAccountData?.roleTypeStr
                ? (myAccountData.roleType | translate)
                : ('MYACCOUNT.NA' | translate) }}</span>
              <span title3>{{ "MANAGEDEVICE.PHONENO" | translate }} : </span>
              <span desc3>{{
                myAccountData?.countryCode !=null ?
                myAccountData?.countryCode + " " : "+91" }}
                {{
                myAccountData?.mobileNo == null
                ? "N/A"
                : myAccountData?.mobileNo
                }}</span>
              <span title4>{{ "MYACCOUNT.EMAIL" | translate }} : </span>
              <span desc4>{{
                myAccountData?.email == null
                ? "N/A"
                : myAccountData?.email
                }}</span>
              <span title5>{{ "MYACCOUNT.AGE" | translate }} : </span>
              <span desc5>{{
                myAccountData?.age == null
                ? "N/A"
                : myAccountData?.age
                }}</span>
              <span title6>{{ "MYACCOUNT.GENDER" | translate }} : </span>
              <span desc6>{{
                myAccountData?.genderType == null
                ? "N/A"
                : myAccountData?.genderType
                }}</span>
            </tab-content>
          </div>
        </ng-container>
      </div>
    </div>
    <div class="mb-4 profile-buttons ms-4">
      <span btn2 *ngIf="!myAccountData?.isSocialLogin"><button class="q-form-white-submit mb-2 me-3 mt-2 mb-0"
          (click)="openChangePassword()">
          {{"MYACCOUNT.CHANGEPWD" | translate }}
        </button>
      </span>
      <span btn2><button class="q-form-white-submit mb-2 me-3 mt-2 mb-5" (click)="logout()">
          {{ "MYACCOUNT.LOGOUT" | translate }}
        </button>
      </span>
    </div>
  </form>
</div>

<!-- remove device popup -->
<div class="modal" id="removeDevicePopup" data-bs-backdrop="static">
  <div class="modal-dialog modal-dialog-centered" id="forgotpwd">
    <ng-container *ngIf="!isProfileRemoved">
      <div class="modal-content px-4 rounded-25">
        <!-- Modal Header -->
        <div class="text-center">
          <div class="mt-3">
            <img src="./assets/images/delete.svg" alt="" class="mx-auto" />
          </div>
          <h5 class="fw-bold mt-3 mb-2">
            {{ "MANAGEDEVICE.REMOVEPROFILEPICTURE.DOYOUWANT" | translate }}
          </h5>
        </div>
        <!-- Modal body -->

        <div class="my-3 d-flex justify-content-center">
          <button (click)="deleteUploadedProfile()" class="submit-btn bg-orgclr me-3">
            {{ "MANAGEDEVICE.REMOVEPROFILEPICTURE.DELETE" | translate }}
          </button>
          <button class="cancel-btn bg-cancelbtn" data-bs-dismiss="modal">
            {{ "MANAGEDEVICE.REMOVEPROFILEPICTURE.CANCEL" | translate }}
          </button>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="isProfileRemoved">
      <div
        class="modal-content rounded-25 border-none shadow-lg relative d-flex flex-column w-100 pointer-events-auto bg-white outline-none">
        <div class="modal-body relative pt-3">
          <div class="text-center">
            <div>
              <img src="./assets/images/SuccessIllustration.png" alt="" class="mx-auto" />
            </div>
            <h5 class="q-modal-heading fw-bold mt-3 mb-0">
              {{ "SUCESSMESSAGE.PROFILEPRICTUREREMOVEDSUCCESSFULLY" | translate }}
            </h5>
            <button class="submit-btn bg-orgclr mt-3 w-auto" data-bs-dismiss="modal">
              {{ "MYACCOUNT.DONE" | translate }}
            </button>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>